import { render, staticRenderFns } from "./ContractorsView.vue?vue&type=template&id=875aaa84&"
import script from "./ContractorsView.vue?vue&type=script&lang=js&"
export * from "./ContractorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports